export default "__VITE_ASSET__BlgdBOpc__"